module.exports = __webpack_public_path__ + "static/media/whiteOval.0e1f8097.svg";